import { minBreakpoints } from '@noths/polaris-client-ribbons-base';

import type { FilterNavType } from 'src/types/navigation';

/**
 * Which filter navigation the current viewport is showing, for the
 * `filter_nav_type` page dimension. Browser only: reads `window.innerWidth`.
 *
 * `filterNavFilterScript` in `src/tracking/events/pageEvent.ts` repeats this
 * logic because it is a stringified inline script and cannot call a function.
 * Keep the two in step.
 */
export const getFilterNavType = (): FilterNavType => {
  if (window.innerWidth >= minBreakpoints.L) {
    return 'fixed sidebar';
  }

  if (window.innerWidth >= minBreakpoints.M) {
    return 'collapsed sidebar';
  }

  return 'sticky filter';
};
